import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Send: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.03403 10.1704V7.48873H6.28057C3.83247 7.48873 1.71183 8.87212 0.676008 10.8809C0.583713 11.0599 0.314012 11.0326 0.256458 10.84C0.0899938 10.2831 0 9.6906 0 9.08929C-2.68421e-07 5.66849 2.80553 2.90674 6.28057 2.90674H8.03403V0.225123C8.03403 0.039073 8.25129 -0.0656925 8.40062 0.0483485L14.912 5.02096C15.0293 5.11053 15.0293 5.28494 14.912 5.37451L8.40062 10.3471C8.25129 10.4612 8.03403 10.3564 8.03403 10.1704Z"
        fill="currentColor"
      />
    </svg>
  )
})

Send.displayName = 'Send'
